/* eslint-disable @typescript-eslint/no-explicit-any */
import { parseAsync } from 'json2csv';

import { User } from '../../common/types/User';

export const downloadUsersCSV = async (data: User[]) => {
  const fields: (keyof User)[] = [
    'email',
    'firstName',
    'lastName',
    'phone',
    'keywordSearchesUsed',
    'scanSearchesUsed',
    'subscription',
    'lastLogin',
    'active',
    'practiceName',
    'role',
    'speciality',
    'organizationName',
  ];
  const opts = { fields };
  try {
    const csv = await parseAsync(data, opts);
    downloadCsvFile(csv);
  } catch (error) {
    console.log(error);
  }
};

const downloadCsvFile = (csv: string) => {
  const dateStr = new Date().toISOString();
  const filename = `Users-${dateStr}.csv`;
  const blob = new Blob([csv], {
    type: 'text/plain;charset=utf-8',
  });
  if (navigator.msSaveBlob) {
    navigator.msSaveBlob(blob, filename);
    return;
  }
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.href = url;
  link.download = filename;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

declare global {
  interface Navigator {
    msSaveBlob?: (blob: any, defaultName?: string) => boolean;
  }
}
